import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Icon } from '@iconify/react/dist/iconify.js';
import Breadcrumb from '../../../components/Breadcrumb';
import { SOCIETY_CONTROLLER, SOCIETY_MANAGEMENT, SOCIETY_MANAGEMENT_COMMUNICATION_SETTINGS } from '../../../Routing/routes';
import CommunicationSettingsLayer from './Component/CommunicationSettingsLayer';
import SmtpConfigLayer from './Component/SmtpConfigLayer';

// Per-community settings: communication permissions, then SMTP email accounts.
const CommunicationSettings = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    // The list passes the community name along; a direct visit falls back to the id.
    const societyName = useLocation().state?.societyName;
    const links = [
        { to: SOCIETY_MANAGEMENT, text: 'Community Management' },
        { to: SOCIETY_MANAGEMENT_COMMUNICATION_SETTINGS.replace(':id', id), text: 'Settings' },
    ];

    return (
        <>
            <Breadcrumb
                replaceClass="mb-24"
                description={societyName
                    ? `Communication and email settings for ${societyName}`
                    : 'Communication and email settings for this community'}
                links={links}
                headingTitle="Settings"
            />

            <div className="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3 tw-mb-4">
                <div className="tw-flex tw-items-center tw-gap-2 tw-min-w-0">
                    <Icon icon="solar:buildings-3-bold-duotone" className="tw-text-lg tw-text-gray-400 tw-flex-shrink-0" />
                    <span className="tw-text-sm tw-font-semibold tw-text-gray-800 tw-truncate">
                        {societyName || `Community #${id}`}
                    </span>
                </div>
                <button onClick={() => navigate(SOCIETY_CONTROLLER + SOCIETY_MANAGEMENT)}
                    className="tw-h-8 tw-inline-flex tw-items-center tw-gap-1.5 tw-px-3 tw-rounded-md tw-text-xs tw-font-medium tw-text-gray-600 tw-bg-white tw-border tw-border-gray-200 hover:tw-bg-gray-50">
                    <Icon icon="mdi:arrow-left" className="tw-text-sm" />
                    Back to Communities
                </button>
            </div>

            <div className="tw-flex tw-flex-col tw-gap-6">
                <CommunicationSettingsLayer societyId={id} />
                <SmtpConfigLayer societyId={id} />
            </div>
        </>
    );
};

export default CommunicationSettings;
